import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
import { AppState } from '../../app/types';
import { GroupId } from '../../config/systemConfig';
import { Card } from '../ui/Card';
import { SectionHeader } from '../ui/SectionHeader';
import { itemVariants } from '../shared/animations';
import { useErrorPatterns } from '../../utils/errorPatterns';
import { RADIUS } from '../../config/designTokens';
// Re-export for any historic consumers that import from this file
// (audit DDD-3, ronde 2 2026 — implementation moved to
// `src/utils/errorPatterns.ts` so the mascot domain can consume it
// without depending on this progress UI module).
export { useErrorPatterns } from '../../utils/errorPatterns';
interface ErrorPatternsSectionProps {
  state: AppState;
  selectedGroup: GroupId;
}
export function ErrorPatternsSection({
  state,
  selectedGroup
}: ErrorPatternsSectionProps) {
  const errorPatterns = useErrorPatterns(state, selectedGroup);
  return <div className="space-y-4" data-id="element-1820">
      <SectionHeader title="Slimme Leertips" icon={Lightbulb} accentColor="bg-violet-100 text-violet-600" data-id="element-1821" />

      {errorPatterns.length === 0 ? <Card className={`p-6 text-center bg-slate-50 border-dashed border-2 border-slate-200 ${RADIUS.card} shadow-sm`} data-id="element-1822">
          <p className="text-slate-500 font-medium" data-id="element-1823">
            Geen specifieke tips — je doet het geweldig! 🌟
          </p>
        </Card> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1824">
          {errorPatterns.map((pattern, i) => <motion.div key={`${pattern.errorType}-${i}`} variants={itemVariants} data-id="element-1825">
              <Card className={`p-5 h-full flex flex-col border-2 border-slate-100 bg-white ${RADIUS.card} shadow-sm hover:shadow-md transition-shadow`} data-id="element-1826">
                <div className="flex items-center gap-3 mb-3" data-id="element-1827">
                  <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-xl shadow-sm ${pattern.moduleColor.replace('bg-', 'bg-opacity-20 text-').replace('500', '700')} bg-opacity-20`} data-id="element-1828">
                    {pattern.moduleIcon}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1829">
                    <h4 className="font-bold text-slate-800 truncate" data-id="element-1830">
                      {pattern.familyName}
                    </h4>
                    <p className="text-xs text-slate-500 font-medium" data-id="element-1831">
                      Tip voor jou
                    </p>
                  </div>
                </div>
                <div className="bg-violet-50 rounded-xl p-4 flex-1" data-id="element-1832">
                  <p className="text-violet-800 text-sm font-medium leading-relaxed" data-id="element-1833">
                    {pattern.recommendation}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </div>}
    </div>;
}